// extracted by mini-css-extract-plugin
module.exports = {"link":"link__2PAh7","title":"title__13wGP"};